import { useState } from 'react';
import debounce from 'lodash.debounce';
import { useOnce } from './use-once';
export var useDebouncedState = function (debounceTime, defaultValue) {
    var _a = useState(defaultValue), value = _a[0], setFinalValue = _a[1];
    var _b = useState(defaultValue), displayValue = _b[0], setDisplayValue = _b[1];
    var _c = useState(function () { return setFinalValue; }), debouncedSet = _c[0], setDebouncedSet = _c[1];
    useOnce(function () { return setDebouncedSet(function () { return debounce(setFinalValue, debounceTime); }); });
    var setValue = function (value) {
        setDisplayValue(value);
        debouncedSet(value);
    };
    return [value, setValue, displayValue];
};
//# sourceMappingURL=use-debounced-state.js.map